<!-- 투약현황 -->
<template>
  <div class="print-container">
    <div class="flex items-center justify-between mb-5">
      <h5 class="flex items-center"><i class="dot"></i>{{ $t('투약현황') }}</h5>
      <div v-if="!readonly && !isPrint" class="flex items-center gap-2">
        <vs-button color="secondary" type="flat" @click="fold = false"><img src="@/assets/images/icon/IconTriangleDown.svg" class="inline-block align-middle" />{{ $t('모두펼치기') }}</vs-button>
        <hr class="-mx-2" style="height: 20px; border-width: 1px; border-color: #6670cb; border-left: 0" />
        <vs-button color="secondary" type="flat" @click="fold = true"> <img src="@/assets/images/icon/IconTriangleDown.svg" class="inline-block align-middle" style="transform: rotate(180deg)" />{{ $t('모두접기') }}</vs-button>
        <vs-button color="secondary" type="border" @click="handleAddRow">{{ $t('항목추가') }}</vs-button>
        <vs-button color="secondary" @click="handleRemoveRow">{{ $t('선택삭제') }}</vs-button>
      </div>
    </div>
    <table v-show="!fold">
      <colgroup>
        <col v-if="!readonly && !isPrint" width="36" />
        <col width="200" />
        <col />
        <col width="240" />
        <col width="100" />
        <col width="100" />
        <col width="100" />
        <col width="100" />
      </colgroup>
      <thead>
        <th v-if="!readonly && !isPrint">
          <vs-checkbox :value="checkData.length === list.length && 0 < list.length" @click.native="onClickAllCheckbox" class="checkbox" />
        </th>
        <th>{{ $t('투약일') }}</th>
        <th>{{ $t('증상') }}</th>
        <th>{{ $t('약품명') }}</th>
        <th>{{ $t('1회 복용량') }}</th>
        <th>{{ $t('회수') }}</th>
        <th>{{ $t('일수') }}</th>
        <th>{{ $t('총량') }}</th>
      </thead>
      <tbody>
        <tr v-for="(item, index) in list" :key="item.id">
          <td v-if="!readonly && !isPrint" class="align-middle p-0">
            <vs-checkbox :vs-value="item.id" v-model="checkData" class="checkbox" />
          </td>
          <td>
            <p v-if="isPrint" class="print-input">{{ item.input_2 }}</p>
            <date-selector v-else v-model="item.input_2" :readonly="readonly" class="w-full" />
          </td>
          <td>
            <p v-if="isPrint" class="print-textarea">{{ item.input_1 }}</p>
            <ml-textarea v-else v-model="item.input_1" :readonly="readonly" class="w-full mb-0" />
          </td>
          <td>
            <fragment v-if="isPrint">
              <p v-for="(_, ipd) in 3" :key="`print_input_3_${ipd}`" class="print-input mb-2" :class="_ === 3 && 'mb-0'">{{ item.input_3[ipd] }}</p>
            </fragment>
            <fragment v-else>
              <ml-input v-for="(_, ipd) in 3" :key="`input_3_${ipd}`" v-model="item.input_3[ipd]" :readonly="readonly" class="w-full mb-2" :class="_ === 3 && 'mb-0'" />
            </fragment>
          </td>
          <td>
            <fragment v-if="isPrint">
              <p v-for="(_, ipd) in 3" :key="`print_input_4_${ipd}`" class="print-input mb-2" :class="_ === 3 && 'mb-0'">{{ item.input_4[ipd] }}</p>
            </fragment>
            <fragment v-else>
              <vs-select
                v-for="(_, ipd) in 3"
                :key="`input_4_${ipd}`"
                v-model="item.input_4[ipd]"
                autocomplete
                :readonly="readonly"
                :disabled="readonly"
                class="w-full mb-2"
                :class="_ === 3 && 'mb-0'"
                @change="onChangeTotal(index, item, ipd)"
              >
                <vs-select-item v-for="option in 3" :key="option" :text="option" :value="option" />
              </vs-select>
            </fragment>
          </td>
          <td>
            <fragment v-if="isPrint">
              <p v-for="(_, ipd) in 3" :key="`print_input_5_${ipd}`" class="print-input mb-2" :class="_ === 3 && 'mb-0'">{{ item.input_5[ipd] }}</p>
            </fragment>
            <fragment v-else>
              <vs-select
                v-for="(_, ipd) in 3"
                :key="`input_5_${ipd}`"
                v-model="item.input_5[ipd]"
                autocomplete
                :readonly="readonly"
                :disabled="readonly"
                class="w-full mb-2"
                :class="_ === 3 && 'mb-0'"
                @change="onChangeTotal(index, item, ipd)"
              >
                <vs-select-item v-for="option in 3" :key="option" :text="option" :value="option" />
              </vs-select>
            </fragment>
          </td>
          <td>
            <fragment v-if="isPrint">
              <p v-for="(_, ipd) in 3" :key="`print_input_6_${ipd}`" class="print-input mb-2" :class="_ === 3 && 'mb-0'">{{ item.input_6[ipd] }}</p>
            </fragment>
            <fragment v-else>
              <vs-select
                v-for="(_, ipd) in 3"
                :key="`input_6_${ipd}`"
                v-model="item.input_6[ipd]"
                autocomplete
                :readonly="readonly"
                :disabled="readonly"
                class="w-full mb-2"
                :class="_ === 3 && 'mb-0'"
                @change="onChangeTotal(index, item, ipd)"
              >
                <vs-select-item v-for="option in 3" :key="option" :text="option" :value="option" />
              </vs-select>
            </fragment>
          </td>
          <td>
            <fragment v-if="isPrint">
              <p v-for="(_, ipd) in 3" :key="`print_input_7_${ipd}`" class="print-input mb-2" :class="_ === 3 && 'mb-0'">{{ item.input_7[ipd] }}</p>
            </fragment>
            <ml-input v-else v-for="(_, ipd) in 3" :key="`input_7_${ipd}`" v-model="item.input_7[ipd]" readonly class="w-full mb-2" :class="_ === 3 && 'mb-0'" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector";
export default {
  components: {
    DateSelector,
  },
  props: {
    value: Array,
    readonly: {
      type: Boolean,
      default: false,
    },
    isPrint: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fold: false,
      checkData: [],
      numberId: 0 < this.value.length ? this.value[this.value.length - 1].id : 0,
      list: this.value,
    };
  },
  watch: {
    value: {
      handler(value) {
        if (typeof value.input_3 === "string") value.input_3 = [value.input_3, "", ""];
        if (typeof value.input_4 === "string") value.input_4 = [value.input_4, "", ""];
        if (typeof value.input_5 === "string") value.input_5 = [value.input_5, "", ""];
        if (typeof value.input_6 === "string") value.input_6 = [value.input_6, "", ""];
        if (typeof value.input_7 === "string") value.input_7 = [value.input_7, "", ""];
        this.list = value;
      },
    },
    list: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    // 항목추가
    handleAddRow() {
      const addData = { id: ++this.numberId, input_3: ["", "", ""], input_4: ["", "", ""], input_5: ["", "", ""], input_6: ["", "", ""], input_7: ["", "", ""] };
      this.list.unshift(addData);
    },
    // 선택삭제
    handleRemoveRow() {
      this.list = this.list.filter((item) => !this.checkData.includes(item.id));
      this.checkData = [];
    },
    // All 체크박스 클릭
    onClickAllCheckbox() {
      if (this.checkData.length === this.list.length) this.checkData = [];
      else this.checkData = this.list.map((item) => item.id);
    },
    onChangeTotal(listIndex, item, arrIndex) {
      if (!!item.input_4[arrIndex] && !!item.input_5[arrIndex] && !!item.input_6[arrIndex]) this.$set(this.list[listIndex].input_7, arrIndex, item.input_4[arrIndex] * item.input_5[arrIndex] * item.input_6[arrIndex]);
      else this.$set(this.list[listIndex].input_7, arrIndex, "");
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox::v-deep {
  justify-content: center !important;
  span {
    margin: 0px !important;
  }
}
.content-container {
  display: flex;

  &:nth-child(n + 3) {
    .checkbox-container {
      border-top: 0px;
    }
    table:first-child {
      tr:first-child th {
        border-top: 0px;
      }
    }
  }

  table:nth-child(n + 2) {
    margin-top: -1px;
  }
}

.checkbox-container {
  width: 36px;

  display: flex;
  justify-content: center;

  background: #f9f9f9;
  border: 1px solid #cdcdcd;
  border-right: 0px;
}
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    background: #f9f9f9;
    padding: 18px 0px;
  }

  td {
    vertical-align: top;
    padding: 7px;
  }
}
</style>
